// Match server validation and the business's Indian calendar day.
export const todayInIndia = () => new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Kolkata", year: "numeric", month: "2-digit", day: "2-digit",
}).format(new Date());

export const isValidPhone = (value) => {
  const phone = value.trim();
  const digits = phone.replace(/\D/g, "");
  return /^\+?[0-9 () .-]+$/.test(phone) && digits.length >= 10 && digits.length <= 15;
};

export const isValidPassengers = (value) => !value || (/^[0-9]{1,3}$/.test(value) && Number(value) >= 1);
